import { Row, Col } from 'react-bootstrap'

const ErrorInterfaz = () => {
    return <div>
            <h4 className="mb-0">Sin información</h4>
            <span style={{ fontSize:11, color: "gray" }}>ESTA INFORMACIÓN NO SE PUEDE VISULIZAR, COMUNÍCATE SON SOPORTE PARA HABILITARLO</span>
        </div>
}

export default ErrorInterfaz